import { makeRequest } from 'utils/requestLogger';

export default () =>
    makeRequest('get', '/api/recents/instructor');


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/getRecentRoundTablesInstructor.js